import { TFunction } from "next-i18next"
import getcdn from "~/modules/get_cdn_link"

const getSteps = (t: TFunction) => ([
  {
    img: getcdn('/images/home/intro-step1.png'),
    title: t`Đầu tư chung một bất động sản`,
    desc: t`Thay vì hình thức đầu tư truyền thống, bạn và nhiều người khác sẽ cùng đầu tư vào một bất động sản với số vốn khởi điểm không quá cao`,

  },
  {
    img: getcdn('/images/home/intro-step2.png'),
    title: t`Mua - Bán theo phần sở hữu của mình`,
    desc: t`Bạn có thể bán phần sở hữu của mình trên sàn giao dịch để chốt lời, hoặc mua lại phần sở hữu từ nhà đầu tư khác`

  },
  {
    img: getcdn('/images/home/intro-step3.png'),
    title: t`Cùng chốt lời khi bán ra nguyên căn`,
    desc: t`Bất động sản bán trên Infina đều được phân tích và theo dõi bởi các chuyên gia hàng đầu, chúng tôi sẽ bán ra bất động sản ở thời điểm lợi nhuận tốt nhất cho bạn`,

  }
])

export default getSteps